export const DEFAULT_SERVER_PATH = "/data/local/tmp/scrcpy-server.jar";
export function isScrcpyOptionValue(value) {
    return (typeof value === "object" &&
        value !== null &&
        "toOptionValue" in value &&
        typeof value.toOptionValue === "function");
}
export function toScrcpyOptionValue(value, empty) {
    if (isScrcpyOptionValue(value)) {
        value = value.toOptionValue();
    }
    // `value` may become `undefined` after `toOptionValue`
    if (value === undefined) {
        return empty;
    }
    return String(value);
}
//# sourceMappingURL=types.js.map